<template>
  <section id="contacts-panel" class="panel panel-default" role="region" aria-labelledby="contacts-heading">
    <div class="panel-body">
      <div class="panel-header">
        <h2 id="contacts-heading">Contacts</h2>
      </div>
      <div v-if="hasLearnerSupport" class="contacts-learner-supports-container">
        <div v-if="programmeCoach" class="contacts-item coach-item">
          <h3>{{ programmeCoach.name }}</h3>
          <p>Coach</p>
          <address>
            <a class="contact-email" :href="`mailto:${programmeCoach.email}`" rel="noopener noreferrer nofollow">{{ programmeCoach.email }}</a>
          </address>
        </div>
        <div v-if="programmeDataMentor" class="contacts-item data-mentor-item">
          <h3>{{ programmeDataMentor.name }}</h3>
          <p>Data Mentor</p>
          <address>
            <a class="contact-email" :href="`mailto:${programmeDataMentor.email}`" rel="noopener noreferrer nofollow">{{ programmeDataMentor.email }}</a>
          </address>
        </div>
        <div v-if="programmeLineManager" class="contacts-item line-manager-item">
          <h3>{{ programmeLineManager.name }}</h3>
          <p>Line Manager</p>
          <address>
            <a class="contact-email" :href="`mailto:${programmeLineManager.email}`" rel="noopener noreferrer nofollow">{{ programmeLineManager.email }}</a>
          </address>
        </div>
      </div>
      <hr v-if="hasLearnerSupport" class="horizontal-hr">
      <div class="contacts-item extra-contacts-container">
        <p>Not sure who to contact?</p>
        <address>
          <a class="contact-email" :href="supportMailto" rel="noopener noreferrer nofollow">{{ supportEmail }}</a>
        </address>
        <p>If you have safety or safeguarding concerns, please email:</p>
        <address>
          <a class="contact-email" :href="safeguardingMailto" rel="noopener noreferrer nofollow">{{ safeguardingEmail }}</a>
        </address>
      </div>
    </div>
  </section>
</template>

<style scoped>
.contacts-learner-supports-container .contacts-item {
  transition: background-color 0.2s ease-in-out;
  padding: 15px;
  border-radius: 8px;
  background-color: var(--kate-background-alpha);
}

.contacts-item {
  margin: 10px 0;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.contacts-item:first-child {
  margin-top: 0;
}

.contacts-item:last-child {
  margin-bottom: 0;
}

.contacts-item h3 {
  margin: 0;
}

.contacts-item p {
  margin: 0;
}

address {
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}

@media (prefers-reduced-motion: reduce) {
  .contacts-learner-supports-container .contacts-item {
    transition: none;
  }
}
</style>

<script>

const SUPPORT_EMAIL = 'help@cambridgespark.com?subject=Contact%20Cambridge%20Spark';
const SAFEGUARDING_EMAIL = 'safeguarding@cambridgespark.com?subject=Report%20Safeguarding%20Concern';

export default {

  props: {
    learnerInfo: {
      type: Object,
      required: true,
    },
    programmeId: {
      type: Number,
      required: true,
    },
  },

  computed: {
    supportEmail() {
      return 'help@cambridgespark.com';
    },
    safeguardingEmail() {
      return 'safeguarding@cambridgespark.com';
    },
    safeguardingMailto() {
      return `mailto:${encodeURIComponent(SAFEGUARDING_EMAIL)}`;
    },
    supportMailto() {
      return `mailto:${encodeURIComponent(SUPPORT_EMAIL)}`;
    },
    programmeCoach() {
      const coach = Array.isArray(this.learnerInfo?.coaches) ? this.learnerInfo.coaches : [];
      return coach.find(c => c?.programme_id === this.programmeId);
    },
    programmeDataMentor() {
      const dataMentor = Array.isArray(this.learnerInfo?.data_mentors) ? this.learnerInfo.data_mentors : [];
      return dataMentor.find(dm => dm?.programme_id === this.programmeId);
    },
    programmeLineManager() {
      const lineManager = Array.isArray(this.learnerInfo?.line_managers) ? this.learnerInfo.line_managers : [];
      return lineManager.find(lm => lm?.programme_id === this.programmeId);
    },
    hasLearnerSupport() {
      return Boolean(this.programmeCoach !== undefined || this.programmeDataMentor !== undefined || this.programmeLineManager !== undefined);
    },
  },
};
</script>
